function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavLeft = function SvgNavLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 35 35"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 33.6c-8.4 0-16.1-7.8-16.1-16.1H.5c0 9.4 7.6 17 17 17zm16.1-16.1c0 8.4-7.8 16.1-16.1 16.1v.9c9.4 0 17-7.6 17-17zM17.5 1.4c8.4 0 16.1 7.8 16.1 16.1h.9c0-9.4-7.6-17-17-17zm0-.9C8.1.5.5 8.1.5 17.5h.9c0-8.4 7.8-16.1 16.1-16.1z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9 21.6 15.2 18l3.7-3.7",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.7095,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 3.7838
    }
  }));
};
export default SvgNavLeft;